import { useEffect, useState } from "react";
import { AdvertisementAPI } from "../../api/AdvertisementAPI";
import { PrivilegeAPI } from "../../api/PrivilegesAPI";
import { ADS_SPONSORSHIP_FEATURE, canViewAdsAnalytics } from "../../util/adsPrivileges";
import AdsAnalytics from "./AdsAnalytics";

const AdsDashboardSection = ({ clubId, userId }) => {
    const [allowed, setAllowed] = useState(false);
    const [analytics, setAnalytics] = useState({ daily: {}, ctr: {}, revenue: {} });

    useEffect(() => {
        if (!clubId || !userId) {
            return undefined;
        }
        let cancelled = false;
        PrivilegeAPI.getAllPrivilegesByFeature({
            userId,
            featureName: ADS_SPONSORSHIP_FEATURE,
        })
            .then((response) => {
                const privileges = response.Data || {};
                if (!canViewAdsAnalytics(privileges)) {
                    return undefined;
                }
                if (!cancelled) {
                    setAllowed(true);
                }
                return Promise.all([
                    AdvertisementAPI.getDailyAnalytics(clubId),
                    AdvertisementAPI.getCtrByPlacement(clubId),
                    AdvertisementAPI.getRevenue(clubId),
                ]).then(([daily, ctr, revenue]) => {
                    if (!cancelled) {
                        setAnalytics({
                            daily: daily.Data || {},
                            ctr: ctr.Data || {},
                            revenue: revenue.Data || {},
                        });
                    }
                });
            })
            .catch(() => {
                if (!cancelled) {
                    setAllowed(false);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [clubId, userId]);

    if (!allowed) {
        return null;
    }

    return (
        <section className="ads-card ads-dashboard-section" data-testid="ads-dashboard-analytics">
            <AdsAnalytics daily={analytics.daily} ctr={analytics.ctr} revenue={analytics.revenue} />
        </section>
    );
};

export default AdsDashboardSection;
